import { render, staticRenderFns } from "./AdicionarCentroCosto.vue?vue&type=template&id=52c6721b"
import script from "./AdicionarCentroCosto.vue?vue&type=script&lang=js"
export * from "./AdicionarCentroCosto.vue?vue&type=script&lang=js"
import style0 from "./AdicionarCentroCosto.vue?vue&type=style&index=0&id=52c6721b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports